import { useParams } from "react-router-dom";
import { ReleaseListPageHeader, ReleaseListTable } from "./components";
import { useFileInquiry } from "@hooks/HRM/employee/useFileInquiry";

const FileInquiry = () => {
  const { id } = useParams();
  const { fileInquiryHistory, isLoading } = useFileInquiry(null, id);
  return (
    <div className="d-flex flex-column gap-10 p-10">
      <ReleaseListPageHeader
        id={id}
        fileInquiryHistory={fileInquiryHistory}
        // refetchFileInquiry={refetchFileInquiryHistory}
      />
      <ReleaseListTable
        id={id}
        fileInquiryHistory={fileInquiryHistory}
        isLoading={isLoading}
      />
    </div>
  );
};
export default FileInquiry;
